import { Pipe, PipeTransform } from '@angular/core';
import {
  SearchConditionOperator,
  SearchQueryConditionsFields,
} from '../components/search-query-form/search-query-form.models';

@Pipe({ name: 'searchQueryField' })
export class SearchQueryFieldPipe implements PipeTransform {
  transform(
    field: SearchQueryConditionsFields,
    operator?: SearchConditionOperator
  ): string {
    const fieldMap: Record<SearchQueryConditionsFields, string> = {
      names: 'Names',
      roles: 'Roles',
      affiliations: 'Affiliations',
      workSettings: 'Work settings',
      industries: 'Industries',
      expertise: 'Expertise',
      publications: 'Publications',
      boardCertifications: 'Board certifications',
      clinicalTrials: 'Clinical trials',
      treatments: 'Treatments',
      medicalConditions: 'Medical conditions',
    };
    const operatorMap: Record<SearchConditionOperator, string> = {
      include: 'Include',
      exclude: 'Exclude',
    };

    const formattedField = fieldMap[field] || field;
    const formattedOperator = operatorMap[operator] || operator;

    if (operator) {
      return `${formattedOperator} ${formattedField.toLowerCase()}`;
    }

    return formattedField;
  }
}
